import React from 'react'
import {bindActionCreators} from "redux";
import {setResultData} from "../actions/nResultActions";
import {connect} from "react-redux";
import Parser from "html-react-parser";

const NResult  = props => {

  const { status, visible, title, message, link, link_tile, setResultData} = props

  const handleClose = e =>{
    setResultData({'visible': false});
    e.preventDefault();
  }

  return (
      visible &&
      <div className="modal fade in result-modal" role="dialog" id="myModal" tabIndex="-1" aria-labelledby="myModalLabel">
          <div className="modal-dialog" role="document">
              <div className="modal-content">
                  <div className={`modal-header${status==="ERROR" ? ' text-danger': ' text-success' }`}>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={ e => handleClose(e)}><span
                          aria-hidden="true">×</span></button>
                      <h4 className="modal-title" id="myModalLabel">{title}</h4>
                  </div>
                  <div className="modal-body">
                      <p>
                          {Parser(message)}
                      </p>
                  </div>
                  <div className="modal-footer">
                      <button type="button" className="btn btn-default" data-dismiss="modal"
                      onClick={ e => handleClose(e)}>Закрыть</button>
                      {link && link_tile &&
                        <a href={link} type="button" className="btn btn-primary">{link_tile}</a>
                      }
                  </div>
              </div>
          </div>
      </div>

)}

const mapStateToProps = state => ({
    status: state.nresult.status,
    visible: state.nresult.visible,
    title: state.nresult.title,
    message: state.nresult.message,
    link: state.nresult.link,
    link_tile: state.nresult.link_tile,
    next_link: state.nresult.next_link,
    next_link_tile: state.nresult.next_link_tile,
})

const mapDispatchToProps = dispatch => bindActionCreators({setResultData}, dispatch);

export default connect(
  mapStateToProps,
    mapDispatchToProps
)(NResult)